import { CommonService } from "../../../../../services/CommonService";
import Language from "../../components/Language";

import { FieldNames } from "../../FieldNames";
import { order } from "../SmartSearchParammeter";
export default async function LanguageSearchConfig(key) {
  let languages = await CommonService.getAllLanguages();
  let languageLevels = await CommonService.getAllLanguageLevels();
  return {
    description: "Language",
    id: "languageId",
    initial: [],
    type: order.second,
    handleValues: (searchObject) => {
      return;
    },

    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <Language
          searchObject={searchObject}
          onChange={onChange}
          setSearchObject={setSearchObject}
          t={t}
          errors={{}}
        />
      </div>
    ),
    operation: ["Exact"],
    list: languages.map((l) => l.description.replace(/,/g, "#")),

    handler: function (searchObj, value) {
      let selected = languages
        .filter((l) => value[0] === l.description.replace(/,/g, "#"))
        .shift();

      searchObj[FieldNames.languageId] = selected.id;
      searchObj["languageLevels"] = languageLevels;
    }
  };
}
